import { fetcher, useApplicantAPI } from "@certn/api";
import {
  ButtonGroup,
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  Select,
  SelectItem,
  PrimaryButton,
  showToast,
} from "@certn/cascadia-react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useApplicationFormContext } from "../../ApplicationFormContext";

type DemoResponseModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
};

export function IncomeVerificationDemoSkipModal({
  isOpen,
  onClose,
  onSave,
}: DemoResponseModalProps) {
  const { caseId } = useApplicationFormContext();
  const { mutate } = useApplicantAPI(
    `/api/internal/applicant/case/${caseId}/` as "/api/internal/applicant/case/{id}/"
  );

  const { t } = useTranslation();
  const { data: options, isLoading } = useApplicantAPI(
    `/api/internal/applicant/case/${caseId}/income-verification/demo-skip-options/` as "/api/internal/applicant/case/{id}/income-verification/demo-skip-options/"
  );
  const [selectedOption, setSelectedOption] = useState<string>("");

  const onPress = async () => {
    try {
      await fetcher.submit(
        `/api/internal/applicant/case/${caseId}/income-verification/demo-skip/`,
        { response: selectedOption }
      );
    } catch (e) {
      console.warn("Unable to call income-verification demo skip api:", e);
      showToast(t("Something went wrong, try again"), {
        type: "error",
      });
    }
    mutate();
    onSave();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Demo Response")}</DialogHeader>
        <DialogContent>
          <Select
            isLoading={isLoading}
            testID="income-verification-demo-response-select-options"
            isRequired
            label="Select result"
            onSelectionChange={(key) =>
              setSelectedOption(key?.toString() ?? "")
            }
            items={options}
            selectedKey={selectedOption}
          >
            {options?.map((option) => (
              <SelectItem
                id={option.value}
                textValue={option.display_value}
                key={option.value}
              >
                {option.display_value}
              </SelectItem>
            ))}
          </Select>
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <PrimaryButton
              testID="income-verification-demo-response-modal-next-step-button"
              size="medium"
              onPress={onPress}
              isDisabled={!selectedOption}
            >
              <Trans>Next step</Trans>
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
